// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {

    // htmlに scroll-behavior: smooth; が指定されている場合のみ一時的にinheritにする
    if ($('html').css('scroll-behavior') === 'smooth') {
      $('html').css({'scroll-behavior': 'inherit'});

      setTimeout(() => {
        $('html').css({'scroll-behavior': 'smooth'});
      }, 500);
    }

    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}